<template>
    <div class="hello">
        <sui-button floated="right" content="Refresh" icon="refresh" v-on:click="refresh()" />
        <h1>Channel list</h1>
    
    <sui-table single-line v-if="aliases && aliases.length>0">
    <sui-table-header>
      <sui-table-row>
        
        <sui-table-header-cell>Channel</sui-table-header-cell>
        <sui-table-header-cell>Last data</sui-table-header-cell>
        <sui-table-header-cell>Devices</sui-table-header-cell>
        <sui-table-header-cell>Detail</sui-table-header-cell>
      </sui-table-row>
    </sui-table-header>
    <sui-table-body>
    <sui-table-row v-for="(alias, aliasIndex) in aliases" :key="aliasIndex">
        <sui-table-cell>{{ alias.alias }}</sui-table-cell>
        <sui-table-cell>{{ alias.lastHistory | moment("from") }}</sui-table-cell>
        <sui-table-cell>{{ alias.devices.length }}</sui-table-cell>
        
        
        <sui-table-cell><router-link :to="'/channel/' + alias.alias" class="nav-link" icon="detail"><sui-button content="Detail" icon="eye" positive  size="mini" /></router-link></sui-table-cell>
    </sui-table-row>
      
    </sui-table-body>
  </sui-table>
  <div v-else>
          <sui-message icon="inbox">
            <sui-message-content>
              <sui-message-header>You can't use channels without devices</sui-message-header>
              You can activate new device by clicking on  <router-link :to="{'name': 'device_activate'}"><sui-button content="Activate new device" icon="plus" size="mini" primary /></router-link>.<br />
            </sui-message-content>
          </sui-message>
          </div>
  
  </div>
  
  
  
</template>

<script>
import DziService from '@/DziService'
import { mapState } from 'vuex'

export default {
    name: 'AliasList',
    computed: mapState([
        'aliases'
    ]),
    methods: {
        refresh() {          
            this.getAliases();  
        },
        async getAliases () {
            const response = await DziService.getAliases()
            this.$store.commit('setAliases', response.data);
            
        }
    },
    mounted () {
        if (!this.$store.state.aliases)
            this.getAliases();
    },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
